import React from "react";
import ServicesModern from "../components/Services/ServicesModern";

const Services = () => {
  return <ServicesModern />;
};

export default Services;
